import { getSyncCategoriesApi } from 'api/ext';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const CACHE_TTL_MS = 4 * 60 * 60 * 1000; // 4 hours

export const useCategoryStore = create(
    persist((set, get) => ({
        categories: [],
        lastFetchedAt: null,
        isLoading: false,
        error: null,

        isCacheValid: () => {
            const { lastFetchedAt, categories } = get();
            if (!lastFetchedAt || !Array.isArray(categories) || categories.length === 0) return false;
            return Date.now() - lastFetchedAt < CACHE_TTL_MS;
        },

        fetchCategories: async (force = false) => {
            if (!force && get().isCacheValid()) return;
            if (get().isLoading) return;

            set({ isLoading: true, error: null });
            try {
                const res = await getSyncCategoriesApi();
                if (!res.success) {
                    throw new Error('Failed to fetch categories');
                }
                const fetched = JSON.parse(res.payload);
                set({
                    categories: fetched,
                    lastFetchedAt: Date.now(),
                    isLoading: false,
                });
            } catch (error) {
                set({ error: error.message, isLoading: false });
            }
        },

        getDepth5Categories: () => {
            return get().categories.filter(item => item.depth === 5);
        },
    }), {
        name: 'category-storage',
        getStorage: () => localStorage,
    })
);
